import React from 'react'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import {
  IconButton,
  Box
} from '@mui/material'
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon
} from '@mui/icons-material'
import { ExpandableConfig, TableData } from '../types'

interface ExpandButtonProps<T extends TableData> {
  expanded: boolean
  hasDetails: boolean
  onToggle: () => void
  expandable: ExpandableConfig<T>
  row: T
  noDetailsComponent?: React.ComponentType<{ row: T }>
}

export const ExpandButton = <T extends TableData>({
  expanded,
  hasDetails,
  onToggle,
  expandable,
  row,
  noDetailsComponent: NoDetailsComponent
}: ExpandButtonProps<T>) => {
  const styles = useStyles()

  const renderExpandIcon = () => {
    if (expandable.expandIcon) {
      const CustomIcon = expandable.expandIcon
      return <CustomIcon expanded={expanded} />
    }
    return expanded ? (
      <ExpandLessIcon fontSize='small' />
    ) : (
      <ExpandMoreIcon fontSize='small' />
    )
  }

  return (
    <div className={styles.container}>
      {!hasDetails && NoDetailsComponent ? (
        <NoDetailsComponent row={row} />
      ) : !hasDetails ? (
        <Box className={styles.spacer} />
      ) : null}
      
      <IconButton
        onClick={(e) => {
          e.stopPropagation()
          onToggle()
        }}
        className={styles.expandButton}
        size='small'
        disabled={!hasDetails}
      >
        {renderExpandIcon()}
      </IconButton>
    </div>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(0.5),
    paddingLeft: theme.spacing(1.25)
  },
  expandButton: {
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    }),
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  spacer: {
    width: '24px'
  }
}))